import React from "react";
import useStyles from "./SpecialAlert.style.js";
import { Button, Dialog, DialogActions, DialogTitle } from "@material-ui/core";
import CheckoutLoader from "../CheckoutLoader/CheckoutLoader.js";

const HolidayModal = ({ title, open, handleClose, isLoading = false }) => {
  const classes = useStyles();
  // console.log("renderinggggggggggggg")

  return (
    <Dialog
      open={open}
      maxWidth="xs"
      className={classes.customPopup}
      onClose={null}
      BackdropProps={{ onClick: null }}
    >
      {isLoading ? (
        <CheckoutLoader />
      ) : (
        <>
          {title && (
            <DialogTitle className={classes.customText}>{title}</DialogTitle>
          )}
          <DialogActions className={classes.customAction}>
            <Button className={classes.actionText} onClick={handleClose}>
              Ok
            </Button>
          </DialogActions>
        </>
      )}
    </Dialog>
  );
};

export default HolidayModal;
